import numeral from "numeral";

// ----------------------------------------------------------------------

export function fNumber(number) {
  return numeral(number).format();
}

export function fCurrency(number) {
  return numeral(number).format(Number.isInteger(number) ? "0,0" : "0,0.00");
}

export function fPercent(number) {
  const format = number ? numeral(Number(number) / 100).format("0.0%") : "";

  return result(format, ".0");
}

export function fShortenNumber(number) {
  if (number === 0) {
    return "0";
  }

  const format = number ? numeral(number).format("0.00") : "";

  return result(format, ".00");
}

export function fData(number) {
  const format = number ? numeral(number).format("0.0 b") : "";

  return result(format, ".0");
}

function result(format, key = ".00") {
  const isInteger = format.includes(key);

  return isInteger ? format.replace(key, "") : format;
}

export function formatToTwoDecimals(number) {
  if (typeof number !== "number" || isNaN(number)) {
    return number;
  }

  return numeral(number).format("0.00");
}
